import React from "react";
import { config } from "./constants";

export class Elements extends React.Component {
  renderElements() {
    if (this.props.elements)
      return this.props.elements.map((item) => {
        let category, link;
        switch (item["var1"]) {
          case "event":
            category = "events/news";
            link = "events";
            break;
          case "Past Event":
            category = "events/news";
            link = "events";
            break;
          case "Past":
            category = "Featured Project";
            link = "projects";
            break;
          case "Current/Ongoing":
            category = "Featured Project";
            link = "projects";
            break;
          default:
            category = "Interviews";
            link = "interviews";
            break;
        }
        return (
          <a key={item["key"]} href={link + "/" + item["key"]}>
            <div className="pageHeadLine">
              <div>{category}</div>
              <div className="clear"></div>
            </div>
            <div>
              <img
                src={config.url.SITE_URL + "files/m_" + item["var5"]}
                alt={item["var0"]}
              />
            </div>
            <h2 dangerouslySetInnerHTML={{ __html: item["var0"] }} />
            <div className="second">
              <div>{item["var2"]}</div>
              <div>
                {item["var3"]}
              </div>
            </div>
            <div className="clear">
              {item["var6"]}
              <br />
              <br />
              read more...
            </div>
          </a>
        );
      });
  }
  render() {
    return <div className="list">{this.renderElements()}</div>;
  }
}
